module.exports = [["translation_id","translation_type","english_source","spanish_translation"],["MG001","Label","Performance","Rentabilidad"],["MG002","Label","From","Desde"],["MG003","Label","To","Hasta"],["MG004","Label","ISIN","Código ISIN"],["MG005","Data","Fixed income","Fondos de renta fija"],["MG006","Data","Equities","Fondos de renta variable"],["MG007","Data","Multi-asset","Fondos multi-activos"],["MG008","Data","Convertibles","Fondos de convertibles"],["MG009","Data","Acc","Acum."],["MG010","Data","Inc","Distr."],[""]]


//////////////////
// WEBPACK FOOTER
// ./src/client/data/translations.json
// module id = 1000
// module chunks = 0